module.exports = __webpack_public_path__ + "static/media/Womens-Day-Mnemonic_01.5888f33e.jpg";